import { render, staticRenderFns } from "./NavbarProgress.vue?vue&type=template&id=5bb5b142&"
import script from "./NavbarProgress.vue?vue&type=script&lang=js&"
export * from "./NavbarProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseCircularProgress: require('/d3_frontend/base-tailwindcss-components/src/CircularProgress.vue').default})
